import { render, staticRenderFns } from "./CustomFmButton.vue?vue&type=template&id=6f72ca4c&"
import script from "./CustomFmButton.vue?vue&type=script&lang=js&"
export * from "./CustomFmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports